<template>
  <v-app>
    <DisconnectDialog
      :enable="disconnectDialogValue"
      :message="disconnectDialogMessage"
    />
    <DrawerToolbar
      :navItems="drawerItems"
      :user="user"
      :show-invoice="showInvoice"
    />
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <Footer :connection="connection" />
    <Snackbar />
  </v-app>
</template>

<script>
import Vue from 'vue'
import {
  DrawerToolbar,
  Footer,
  DisconnectDialog,
  i18n
} from '@leapsight/portal'
import store from '@/store'
import Snackbar from '@/components/snackbar/Snackbar'
import { ConnectionWSShared, magentaOAuth } from '@leapsight/styleguide'
import { GlobalHelpers, TagsHelpers } from '@/helpers/mainExports.js'

export default Vue.extend({
  name: 'App',
  components: {
    DrawerToolbar,
    Footer,
    DisconnectDialog,
    Snackbar
  },
  computed: {
    connection() {
      return store.getters['auth/connection']
    },
    disconnectDialogValue() {
      return this.$store.state.disconnectDialogValue
    },
    disconnectDialogMessage() {
      return this.$store.state.disconnectDialogMessage
    },
    user() {
      return {
        name: this.$store.state.user.name,
        last_name: this.$store.state.user.last_name,
        avatarImage: this.$store.state.user.photo
      }
    },
    userId() {
      return store.getters.getUserId
    }
  },
  methods: {
    showInvoice() {
      return store.getters.isAdmin && store.getters.getCountryId === 'ar'
    },
    async manageAuthAndConnection() {
      if (!store.getters['auth/isLoggedIn']) return
      try {
        const isTokenActive = await store.dispatch('auth/checkTokenIsActive')

        if (ConnectionWSShared.isConnectionOpen()) {
          store.dispatch('auth/getConnection', {})
        }

        if (isTokenActive) {
          store.dispatch('auth/establishConnection')
        } else {
          let willRetry = true
          for (let i = 0; i < 3 && willRetry; i++) {
            try {
              const res = await magentaOAuth.refreshToken()
              if (res.status === 200) {
                store.dispatch('auth/establishConnection')
                willRetry = false
              } else if (res.status >= 400 && res.status < 500) {
                store.commit('auth/logout')
                localStorage.clear()
                router.push({ name: 'login' }).then(() => {
                  window.location.reload()
                })
                willRetry = false
              } else {
                willRetry = true
              }
            } catch (err) {
              console.error(err)
              store.commit('auth/logout')
              localStorage.clear()
              router.push({ name: 'login' }).then(() => {
                window.location.reload()
              })
              willRetry = false
            }
          }
        }
      } catch (error) {
        console.error(
          'Error in authentication and connection management:',
          error
        )

        store.dispatch('auth/logout')
      }
    }
  },
  data: () => ({
    snackbar: true,
    drawerItems: [
      {
        text: i18n.t('fleet_management.general.app.labels.entities'),
        icon: 'icon_truck',
        to: '/fleet-management/entities',
        id: 'idEntidades'
      },
      {
        text: i18n.t('fleet_management.general.app.labels.persons'),
        icon: 'icon_new_user',
        to: '/fleet-management/persons',
        id: 'idPersons'
      },
      {
        text: i18n.t('fleet_management.general.app.labels.geofences'),
        icon: 'icon_geofences',
        to: '/fleet-management/geofences',
        id: 'idZonas'
      },
      {
        text: i18n.t('fleet_management.general.app.labels.agents'),
        icon: 'icon_agents',
        to: '/fleet-management/agents',
        id: 'idEventos'
      },
      {
        text: i18n.t('fleet_management.general.app.labels.tags'),
        icon: 'icon_tags',
        to: '/fleet-management/tags',
        id: 'idEtiquetas'
      },
      {
        text: i18n.t('fleet_management.general.app.labels.points_of_interest'),
        icon: 'icon_points_of_interest',
        to: '/fleet-management/points-of-interest',
        id: 'idPuntosDeInteres'
      },
      {
        text: i18n.t('fleet_management.general.app.labels.person_groups'),
        icon: 'icon_person_groups',
        to: '/fleet-management/person-groups',
        id: 'idGruposDePersonas'
      }
    ]
  }),
  watch: {
    async userId(value) {
      if (value) {
        try {
          const res = await store.dispatch('tags/getTagsList')
          if (res && res.length > 0) {
            TagsHelpers.setTagsInLocalStorage(res)
          } else {
            TagsHelpers.setTagsInLocalStorage([])
          }
        } catch (err) {
          console.error(err)
          TagsHelpers.setTagsInLocalStorage([])
        }
      }
    }
  },
  async created() {
    const countryId = localStorage.getItem('country_id')
    //Guardo en LocalStorage la zona horario de la cuenta para poder acceder desde day.js en las demas apps
    const timeZoneName = GlobalHelpers.getTimeZoneName(countryId)
    localStorage.setItem('timeZone', timeZoneName)

    await this.manageAuthAndConnection()
  },
  mounted() {
    window.addEventListener('single-spa:app-change', event => {
      const mountedApp = Object.keys(event.detail.newAppStatuses)
      if (mountedApp[0] == '@leapsight/fleet-management') {
        return (window.document.title = `${i18n.t(
          'portal.general.app_list.labels.strix'
        )} - ${i18n.t('general.apps.fleet_management')}`)
      }
    })
  }
})
</script>
<style lang="scss" scoped>
.v-main__wrap {
  > .container {
    height: 100%;
  }
}
</style>
